<template>
  <el-dialog title="拟定文档" :visible.sync="showDialog" append-to-body top="50px" width="1000px">
    <div class="box">
      <div class="select-module">
        <span class="lable">选择模板：</span>
        <el-select size="small" v-model="value" placeholder="请选择" @change="moduleChange">
          <el-option
            v-for="item in newTemplateList"
            :key="item.id"
            :label="item.name"
            :value="item.index">
          </el-option>
        </el-select>
      </div>
      <Cheditor ref="cheditor" v-if="showDialog" v-model="content" />
      <div class="btns">
        <el-button type="primary" size="small" :loading="btnLoading" @click="getContent">确定</el-button>
        <el-button type="primary" size="small" @click="openDialog">保存为模板</el-button>
      </div>
    </div>
     <!-- <img :src="base64Url" alt=""> -->
    <el-dialog title="保存模版" :visible.sync="showDialog2" append-to-body width="50%">
      <el-form :model="ruleForm" size="small" :rules="rules" ref="ruleForm" label-width="80px">
        <el-form-item label="模版名称" prop="name">
          <el-input size="small" v-model="ruleForm.name">
          </el-input>
        </el-form-item>
        <el-form-item label="模式" prop="isAdd">
          <el-radio-group v-model="ruleForm.isAdd">
            <el-radio label="add">保存为新模版</el-radio>
            <el-radio label="update">更新当前模板</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" @click="submitForm('ruleForm')">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-dialog>
</template>

<script>
import Cheditor from '@/components/cheditor';
import {myConfirm} from "@/utils/tools.js";
import QRCode from 'qrcode';
import {mapGetters} from 'vuex';
import config from '@/config';
export default {
  props: {
    btnLoading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Cheditor
  },
  data() {
    return {
      showDialog: false,
      showDialog2: false,
      options: [{
          value: 0,
          label: '模版1'
        }, {
          value: 1,
          label: '模板2'
        }],
      value: '',
      content: "",
      templateList:[],
      ruleForm: {
        name: '',
        isAdd: 'add'
      },
      rules: {
        name: [
          { required: true, message: '请输入模版名称', trigger: 'blur' },
        ],
        isAdd: [
          { required: true, message: '请选择保存模式', trigger: 'change' }
        ]
      },
      templateId: '',
      base64Url: ''
    }
  },
  mounted() {
   
   
    
  },
  computed: {
    ...mapGetters({
      storeCaseInfo: "case/caseInfo", // 公证事项
      storeNotaryNo: "case/notaryNo", // 公证事项
    }),
    newTemplateList() {
      let tempList = [...this.templateList];
      tempList.map((item, index) => {
        item.index = index;
      })
      return tempList;
    }
  },
  methods: {
    async createQRCode() {
      // 生成二维码
      return QRCode.toDataURL(`${config.h5Host}?notaryNo=${this.storeCaseInfo.notaryNo}`)
    },
    open() {
      this.showDialog = true;
      this.getList()
      console.log("storeCaseInfo",this.storeCaseInfo)
    },
    close() {
      this.showDialog = false;
    },
    getCon(content) {
      this.content = content;
    },
    async getContent() {
      if (this.content === '') {
        this.$message({
          message: '内容不能为空',
          type: 'warning'
        });
        return;
      }
      

      try {
        let res = await this.createQRCode();
        this.base64Url = res;
        
      } catch (error) {
        console.log(error)
      }

      this.$emit('save', `<!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Document</title>
          <style>
            html,body{
              width: 100%;
              height: 100%;
              box-sizing: border-box;
              padding: 10px;
              margin: 0;
            }
          </style>
        </head>
        <body>
            ${this.content}
        </body>
        </html>`);
    },
    openDialog() {
      if (this.content === '') {
        this.$message({
          message: '内容不能为空',
          type: 'warning'
        });
        return;
      }
      this.showDialog2 = true;
    },
    moduleChange(index) {
      this.content = this.templateList[index].content;
      this.templateId = this.templateList[index].id;
      // 储存模板id
      this.$store.commit('makeCard/updateTemplateId', this.templateId);
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(this.ruleForm);
          let obj;
          if (this.ruleForm.isAdd === 'add') {
            obj = {
              name: this.ruleForm.name,
              content: this.content
            }
          } else {
            obj = {
              name: this.ruleForm.name,
              content: this.content,
              id: this.templateId,
            }
          }
          this.$api.saveTemplate(obj).then(res => {
            if (res.data.code === '200') {
              this.showDialog2 = false;
              this.$message({
                message: '模版保存成功',
                type: 'success'
              });
              this.getList();
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning'
              });
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 获取模版
    getList() {
      this.$api.getnotaryTemplateList({
        pageSize: 10000,
        pageNum: 1,
        contractId: this.storeCaseInfo.contractId,
        type:0
      }).then(res => {
        this.templateList = res.data.data.records;
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import '../../../../style/mixin';
.editor{
  margin-top: 20px;
  margin-bottom: 20px;
}
.btns {
  margin-top: 20px;
  .flex(flex-end);
}
.box{
  padding: 0 40px;
}
.select-module{
  margin-bottom: 10px;
}
</style>